module.exports = __webpack_public_path__ + "img/bild-e.7541f33e.png";